import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight, Sparkles, Shield, Clock, ThumbsUp } from 'lucide-react';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('kontakti');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="sakums" className="relative pt-32 pb-20 overflow-hidden">
      {/* Background with image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-sky-50 via-blue-50 to-white"></div>
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1536509814050-49f492a201b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdpbmRvd3N8ZW58MHx8fHwxNzczNzU0MjAzfDA&ixlib=rb-4.1.0&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 overflow-hidden">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium">
              <Sparkles className="w-4 h-4" />
              <span>Profesionāla logu tīrīšana Latvijā</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Tīri logi,<br />
              <span className="text-sky-500">perfekta kvalitāte</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Strādājam rūpīgi, kvalitatīvi un bez steigas. Nodrošinām profesionālu logu tīrīšanu gan privātpersonām, gan uzņēmumiem visā Latvijā.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 text-sky-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Izcila kvalitāte</p>
                  <p className="text-sm text-gray-600">Bez švīkām</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <ThumbsUp className="w-5 h-5 text-sky-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Pieredzējuši tīrītāji</p>
                  <p className="text-sm text-gray-600">Pozitīva attieksme</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-sky-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Ātra apkalpošana</p>
                  <p className="text-sm text-gray-600">Strādājam katru dienu</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Sparkles className="w-5 h-5 text-sky-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Kvalitātes kontrole</p>
                  <p className="text-sm text-gray-600">Perfekta tīrība</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToBooking}
                size="lg"
                className="bg-sky-500 hover:bg-sky-600 text-white text-lg px-8 py-6"
              >
                Pieteikt tīrīšanu
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => {
                  const element = document.getElementById('pakalpojumi');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                size="lg"
                variant="outline"
                className="text-lg px-8 py-6 border-2 border-sky-200 hover:border-sky-300 hover:bg-sky-50"
              >
                Uzzināt vairāk
              </Button>
            </div>
          </div>

          {/* Right image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets-eiarnc6j.emergentagent.net/job_window-care/artifacts/tukfhewk_PHOTO-2025-nosw.webp"
                alt="Professional window cleaning"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>

            {/* Floating card - improved positioning */}
            <div className="absolute bottom-4 left-4 right-4 md:bottom-auto md:top-8 md:right-8 md:left-auto bg-white rounded-xl shadow-xl p-4 md:p-6 max-w-xs mx-auto md:mx-0">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-sky-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-white" />
                </div>
                <div>
                  <p className="text-xl md:text-2xl font-bold text-gray-900">300+</p>
                  <p className="text-sm md:text-base text-gray-600">Apmierināti klienti</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
